import { defineComponent, computed } from 'vue';

var script = defineComponent({
    name: 'InfoSubtitle',
    props: {
        isLightGrey: {
            type: Boolean,
            default: false,
        },
        isBold: Boolean,
    },
    setup(props) {
        const classNames = computed(() => {
            const names = ['InfoSubtitle'];
            if (props.isLightGrey)
                names.push('InfoSubtitle--light-grey');
            if (props.isBold)
                names.push('InfoSubtitle--bold');
            return names;
        });
        return {
            classNames,
        };
    },
});

export { script as default };
